import type { IconSizeScale, IconSpecs } from './types';

export const BRAVEMOVE_ICONS: IconSpecs = {
  ui: { strokeWidth: 1.6, fill: 'none', cap: 'round', join: 'round' },
  sport: { strokeWidth: 2.0, fill: 'none', cap: 'round', join: 'round', accentDot: true },
  status: { strokeWidth: 0, fill: 'solid', cap: '—', join: '—', color: 'semantic' },
};

export const BRAVEMOVE_ICON_SIZE: IconSizeScale = {
  xs: 14,
  sm: 20,
  md: 24,
  lg: 32,
  xl: 44,
};
